import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backer_center_thumbnail = _resolveComponent("backer-center-thumbnail")
  const _component_base_text = _resolveComponent("base-text")
  const _component_backer_center_header = _resolveComponent("backer-center-header")
  const _component_order_statuses_list = _resolveComponent("order-statuses-list")

  return (_openBlock(), _createElementBlock("div", {
    class: "_flexcol _gap-1 _py-3 _px-2",
    "data-qa": `pledges-dashboard-row:${$props.orderID}`
  }, [
    _createVNode(_component_backer_center_header, null, {
      prefix: _withCtx(() => [
        _createVNode(_component_backer_center_thumbnail, {
          url: $props.yourPledgeUrl,
          "image-url": $props.imageUrl,
          name: $props.name
        }, null, 8 /* PROPS */, ["url", "image-url", "name"])
      ]),
      suffix: _withCtx(() => [
        _createVNode(_component_base_text, {
          level: "b1",
          "data-qa": "order-card:TotalAmount"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.totalAmountFormatted), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_base_text, {
          as: "a",
          level: "b1",
          class: "_toe",
          title: $props.name,
          href: $props.yourPledgeUrl,
          "data-qa": "order-card:ProjectName"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.name), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title", "href"])
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", null, [
      _createVNode(_component_order_statuses_list, {
        "order-stage": $props.stage,
        "payment-status": $props.paymentStatus
      }, null, 8 /* PROPS */, ["order-stage", "payment-status"])
    ]),
    _createVNode(_component_base_text, {
      level: "caption",
      class: "_tc--light"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.format(_ctx.Resources.Common.ElementModifiedParagraph, $options.updatedAtFormatted)), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    })
  ], 8 /* PROPS */, _hoisted_1))
}